import { BaseService } from '../../infra/base.service'
import type { Channel } from './channel'
import type { ChannelsRepository } from './channels.repository'
import type { EvoGetConnectionDto } from './dto/evo-get-connection.dto'

export class ChannelsService extends BaseService<Channel> {
    constructor(private rep: ChannelsRepository) {
        super(rep)
    }

    async evoGetConnection(channelId: string): Promise<EvoGetConnectionDto> {
        return await this.rep.evoGetConnection(channelId)
    }

    async getAppData(): Promise<any> {
        return await this.rep.getAppData()
    }

    async evoLogout(channelId: string): Promise<any> {
        return await this.rep.evoLogout(channelId)
    }

    async uazapiGetConnection(channelId: string): Promise<EvoGetConnectionDto> {
        return await this.rep.uazapiGetConnection(channelId)
    }

    async uazapiLogout(channelId: string): Promise<any> {
        return await this.rep.uazapiLogout(channelId)
    }

    async wabaLogout(channelId: string): Promise<any> {
        return await this.rep.wabaLogout(channelId)
    }

    async wabaToken(channelId: string, code: string): Promise<any> {
        return await this.rep.wabaToken(channelId, code)
    }

    async gmailLogout(channelId: string): Promise<any> {
        return await this.rep.gmailLogout(channelId)
    }

    async gmailToken(channelId: string, code: string, redirectUri: string): Promise<any> {
        return await this.rep.gmailToken(channelId, code, redirectUri)
    }
}
